// extracted by mini-css-extract-plugin
export default {"wrapper":"ActiveMethod_wrapper__1lV-3","tooltip":"ActiveMethod_tooltip__a4asa","content":"ActiveMethod_content__Xve6W","arrow":"ActiveMethod_arrow__pjfQG"};